import React, { Component } from 'react';
import { connect } from 'dva';
import './hotRecommend.less';
import ABSPanel from '../../../../../components/ABSPanel';
import { Row, Col } from 'antd';
import HotRecommendList from './hotRecommendList';
import { formatExpert } from '../../../../views/expert/ExpertSquare/util';
import ABSExpertListContainer from '../../../../../components/ABSExpertListContainer';
import ABSIconTooltip from '../../../../../components/ABSIconTooltip';
import ABSParagraph from '../../../../../components/ABSParagraph';
import ABSSubTitle from '../../../../../components/ABSSubTitle';

export interface IABSHotRecommendProps {
  dispatch: any;
  // recommendProperty: any;
  recommendProduct: any;
  recommendExpert: any;
}

class HotRecommend extends Component<IABSHotRecommendProps> {
  componentDidMount() {
    this.props.dispatch({
      type: 'home/getHomePageRecommand', payload: { hot_expert_count: 30, is_for_home: true}
    });
  }
  render() {
    const { recommendProduct } = this.props;
    let { recommendExpert } = this.props;
    recommendExpert = formatExpert(recommendExpert);
    return (
      <div className="abs-home-right-hot-recommend">
        <ABSPanel 
          title="市场热门" 
          comment={null} 
          hasBorder={false} 
          removePadding={true} 
          removeMargin="top" 
          isClearBackground={true}
        >
          <Row className="abs-row">
            {/* <Col span={12} style={{paddingRight: 2}}>
              <HotRecommendList hotRecommend={recommendProperty} bgName="home-property-bg" recommendType="资产"/>
            </Col> */}
            <Col span={24}>
              <HotRecommendList hotRecommend={recommendProduct} bgName="home-product-bg" recommendType="产品"/>
            </Col>
          </Row>
          <div className={`abs-home-right-hot-recommend-expert-title home-expert-bg`}>
            <ABSSubTitle title="专家" className="abs-home-right-hot-recommend-expert-title-name" />
            <div className="abs-home-right-hot-recommend-expert-title-message">
              <ABSIconTooltip
                width={200}
                placement={'topRight'}
                details={
                  <ABSParagraph>
                    CNABS为您推荐的市场热门专家，快去关注他们吧!
                  </ABSParagraph>
                }
              />
            </div>
          </div>
          <ABSExpertListContainer 
            experts={recommendExpert}
            emptyText={'暂无数据'}
            className={`abs-home-right-hot-recommend-expert`}
            expertClassName={`abs-home-right-hot-recommend-expert-card`}
            size="middle"
            showAllButtons={true}
          />
        </ABSPanel>
      </div>
    );
  }
}

function mapStateToProps({ home, global }: any) {
  const { recommendProduct, recommendExpert } = home; // recommendProperty,
  return { recommendProduct, recommendExpert }; // recommendProperty, 
}

export default connect(mapStateToProps)(HotRecommend); 



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/home/component/right/hotRecommend.tsx